import React from "react";

export const ArrowDownIcon = React.memo(({color = "var(--messenger-grey-2)"}: any) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.5 6.25L10 13.75L2.5 6.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
});